<div
  class="mat-mdc-dialog-surface mdc-dialog__surface !bg-[#FFFFFF] !p-0"
  style="
    overflow: visible;

    background: var(--Bg-pop-up, #FFFFFF);
  "
>
  <div class="flex bg-[#ADB5BD]">
    <h2
      class="!text-[16px] !font-semibold !text-[#21252A] !font-roboto w-full pl-[21px] h-[40px] items-center"
    >
    Custom Work Package
    </h2>
    <mat-icon
      class="text-[#21252A] !mt-[1rem] !mr-[0.7rem] !font-extrabold"
      (click)="onClose()"
      style="cursor: pointer"
      >close</mat-icon
    >
  </div>

  <div class="form-group flex !mt-[30px]">
    <!-- <input id="parent-work-package" class="form-control bg-[#5c7d97] border border-[#1A4971]" [(ngModel)]="parentWorkPackage" disabled /> -->
    <mat-form-field class="form-select" appearance="outline">
      <mat-label class="!relative !top-[-3px]"
        >Parent Work Package</mat-label
      >
      <mat-select (selectionChange)="onCategoryChange($event.value)">
        <mat-option *ngFor="let parent of relatedItems" [value]="parent?.id">
          {{ parent?.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="form-group flex">
    <mat-form-field appearance="outline" class="form-select">
      <mat-label>Work Package Name</mat-label>
      <input
        matInput
        id="work-package"
        [(ngModel)]="workPackage"
        placeholder="Enter Work Package Name"
      />
    </mat-form-field>
  </div>

  <div class="button-group !justify-end  p-[14px]">
    <button (click)="addKeyword()" class="back-btn">Save & Add</button>
    <button class="next-btn" (click)="saveClose()">Save & Close</button>
  </div>
</div>
